<template>
  <div class="layout">
    <b-header
      :env="env"
      :locale="locale"
      :isBstation="useBstation"
      :user="userInfoPart"
      :isMobile="false"
      :showMenu="true"
      @logout="handleLogout"
      @langChange="handleLangChange"
      @menuClick="handleNavToggle"
    />
    <div class="layout__body" >
      <b-sidebar
        :env="env"
        type="collapsed"
        :mid="userInfo?.mid"
        :locale="locale"
        :isMobile="false"
        :isLogin="isLogin"
        :toggleWidth="navToggle"
        :isBstation="useBstation"
        @toggle="handleNavToggle"
      />
      <main class="layout__content">
        <router-view />
      </main>
    </div>
    <b-cookie-info :env="env" :locale="locale"/>
  </div>
  
</template>

<script lang="ts" setup>
import { computed, unref, ref } from 'vue';
import { useStore } from 'vuex';
import { getEnv } from '@/common/env';
import GiftCache from '@/common/gift-cache';
import LangManager from '@/locales/lang-manager';
import { BSidebar } from '@bilibili-intl/sidebar';
import { BHeader } from '@bilibili-intl/header';
import { BCookieInfo } from '@bilibili-intl/cookie-info';

// base
const store = useStore();

// data
const env = getEnv();
const locale = computed(() => LangManager.get());
const useBstation = computed(() => store.state.global.useBstation);
const userInfo = computed(() => store.state.global.userInfo);
const userInfoPart = computed(() => {
  const user = unref(userInfo);
  if (user?.is_login) {
    return {
      mid: user.mid,
      name: user.nickname,
      avatar: user.avatar,
    };
  }
  return null;
});

const isLogin = computed(() => {
  const user = unref(userInfo);
  return user?.is_login;
});

const navToggle = ref(false);
const handleNavToggle = () => {
  navToggle.value = !navToggle.value;
};

// method
const handleLogout = () => {
  window.location.reload();
};

const handleLangChange = (lang: string) => {
  GiftCache.clearCache();
  LangManager.refresh(lang);
};
</script>

<style lang="less" scoped>
.layout {
  min-height: 100vh;

  &__body {
    margin: 0 auto;
    padding-top: 64px;
  }
}
</style>